import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import PropTypes from 'prop-types';
import React from 'react';
import EditModal from '../../common/modal/EditModal';
import RowDisplay from '../../common/RowDisplay';
import { get } from 'lodash';
import EditMaritalInformation from './components/EditMaritalInformation';
import enums from '../../../constants/enums';
import { useAppContext } from '../../../context/context';
function MaritalInformation(props) {
  var _context;
  var contact = props.contact;
  var _useAppContext = useAppContext(),
    fieldsConfig = _useAppContext.state.fieldsConfig;
  var maritalStatus = _findInstanceProperty(_context = enums.people.marital_status).call(_context, function (status) {
    return status.value === contact.marital_status;
  });
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Edit Marital Status",
    size: "normal",
    formName: "edit-marital-status",
    editButtonId: "edit-marital-status-btn",
    id: "edit-marital-modal",
    showEdit: get(fieldsConfig, 'maritalStatusSection.showEdit')
  }, /*#__PURE__*/React.createElement(EditMaritalInformation, {
    contact: contact
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    editSection: editSection,
    label: "Marital Status"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("p", {
    "data-test-element": "marital-display",
    className: "profile-value"
  }, get(maritalStatus, 'display_name', null))));
}
MaritalInformation.propTypes = {
  contact: PropTypes.object.isRequired
};
export default MaritalInformation;
//# sourceMappingURL=index.js.map